import { Color } from '@persona-id/design-tokens';
import { CircleCheckIcon, CircleNullIcon, CircleXIcon } from '@persona-id/design-tokens/icons';
import styled from 'styled-components';

import HelpIcon from 'dashboard/components-lib/HelpIcon';
import { CheckStatus } from 'dashboard/models/check';
import { ComparisonNameMap } from 'dashboard/models/check-result/check-requirement';
import { ComparisonResult } from 'dashboard/models/check-result/check-result';

const iconProps = {
  height: '20px',
  width: '20px',
};

const ComparisonResultContainer = styled('p')`
  display: flex;
  align-items: center;
`;

interface ComparisonResultTooltipProps {
  attributeComparisonResults: ComparisonResult[];
}

const getIcon = (status: CheckStatus) => {
  if (status === CheckStatus.Passed) {
    return <CircleCheckIcon color={Color.BorderIconSuccess} {...iconProps} />;
  } else if (status === CheckStatus.NotApplicable) {
    return <CircleNullIcon {...iconProps} />;
  } else {
    return <CircleXIcon color={Color.BorderIconDanger} {...iconProps} />;
  }
};

const ComparisonResultTooltip = ({ attributeComparisonResults }: ComparisonResultTooltipProps) => {
  return (
    <HelpIcon popoverWidth={null}>
      <b>Comparison Methods</b>
      {attributeComparisonResults.map((comparison) => (
        <ComparisonResultContainer key={comparison['comparison-type']}>
          {getIcon(comparison.status)}
          &nbsp;{ComparisonNameMap[comparison['comparison-type']]}
          &nbsp;(min: {comparison['match-level-minimum']})
        </ComparisonResultContainer>
      ))}
    </HelpIcon>
  );
};

export default ComparisonResultTooltip;
